import type { Filter } from '$gql/storefront/schemas';
import { FILTERS_VENDOR_PREFIX } from '$lib/constants';

export const getTotalFromCollectionQueryFilters = (filters: Filter[]) => {
  // Storefront API will return a list of applied filters and the count of macthes for each one,
  // One of the filters is "Vendor is Hey harper" which logically matches all products and as such it representts the total products in the collection.
  const vendorFilterID = FILTERS_VENDOR_PREFIX + '.hey-harper';

  let sum = 0;

  filters.forEach((filter) => {
    filter.values.forEach((val) => {
      if (val.id.includes(vendorFilterID)) {
        sum += val.count;
      }
    });
  });

  return sum;
};
